module.exports = __webpack_public_path__ + "img/1836.8447e7b9.gif";